module.exports = __webpack_public_path__ + "img/9788952215147.cdfc9ea3.jpg";